import { render, staticRenderFns } from "./MicrositeDetails.vue?vue&type=template&id=644913c9&"
import script from "./MicrositeDetails.vue?vue&type=script&lang=js&"
export * from "./MicrositeDetails.vue?vue&type=script&lang=js&"
import style0 from "./MicrositeDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VListItem,VSkeletonLoader})
